import { forwardRef, RefAttributes } from "react";
import styles from "./TooltipButton.module.scss";
import { ReactComponent as InfoIcon } from "components/icons/info.svg";
import { ReactComponent as InfoDarkIcon } from "components/icons/info-dark.svg";

const TooltipButton = forwardRef<HTMLSpanElement, RefAttributes<HTMLSpanElement>>((props, ref) => {
  return (
    <button style={{ position: "relative" }} {...props} className={styles.root} ref={ref}>
      {props.dark ? <InfoDarkIcon /> : <InfoIcon />}
    </button>
  );
});

export default TooltipButton;
